// Fixed vocabulary for the reference_outbound `target_resource` dimension.
// Only the resources that actually render as OUTBOUND links on the detail page
// this iteration. PubMed/DOI are intentionally absent: the detail page's
// reference list links internally to /references, not out to PubMed/DOI, so
// firing those would mislabel internal clicks. Add them only when real
// outbound PubMed/DOI links exist on the page.
export const TARGET_RESOURCE = {
  OMIM: 'omim',
  NCBI_GENE: 'ncbi_gene',
  CLINGEN: 'clingen',
};

// Thin wrapper over gtag. The guard defends against the inline gtag snippet in
// public/index.html being removed or absent (e.g. a future consent-gated load).
// It does NOT buy tracker-blocker resilience: blockers block the remote
// googletagmanager script, not the inline `function gtag(){...}` definition.
export function trackEvent(name, params) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}
